var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergynew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.493,
    height: 16.5,
    viewBox: "0 0 14.493 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#055ca7;}.a{stroke:#055ca7;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.022 -4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.575,11.784a6.89,6.89,0,0,0-1.357-4.635A6.268,6.268,0,0,0,17.3,5h-.07A6.333,6.333,0,0,0,12.3,7.149a6.89,6.89,0,0,0-1.357,4.635,1.926,1.926,0,0,0-.617,1.065,3.464,3.464,0,0,0,.123,1.7,2.345,2.345,0,0,0,1.286,1.616,8.926,8.926,0,0,0,3.347,4.173,3.96,3.96,0,0,0,4.369,0A8.926,8.926,0,0,0,22.8,16.17a2.385,2.385,0,0,0,1.286-1.616,3.455,3.455,0,0,0,.123-1.7A1.994,1.994,0,0,0,23.575,11.784Zm-.132,2.468c-.229.835-.74.994-1.022.994-.018,0-.053.018-.053.036a9.6,9.6,0,0,1-3.5,4.538,2.964,2.964,0,0,1-1.6.479,2.92,2.92,0,0,1-1.6-.479,9.6,9.6,0,0,1-3.5-4.538c0-.018-.035-.036-.053-.036-.264,0-.793-.178-1.022-.994-.247-.906-.229-1.6.564-1.882.018,0,.035-.036.035-.053-.088-.533-.361-6.4,5.576-6.633,5.937.231,5.665,6.083,5.576,6.633,0,.018.018.053.035.053C23.672,12.654,23.69,13.346,23.443,14.252Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.028,64.991a2.783,2.783,0,0,0-1.48-.391,2.608,2.608,0,0,0-1.568.462.16.16,0,0,0-.018.249l.159.178a.164.164,0,0,0,.229.018,2.14,2.14,0,0,1,1.216-.337,2.329,2.329,0,0,1,1.145.284.166.166,0,0,0,.229-.036l.141-.2A.159.159,0,0,0,44.028,64.991Z",
    transform: "translate(-25.245 -49.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.972,41.457l-.141-.142a.137.137,0,0,0-.194,0,1.775,1.775,0,0,1-.969.373,1.9,1.9,0,0,1-.969-.142.122.122,0,0,0-.176.053l-.106.178a.143.143,0,0,0,.053.2,2.4,2.4,0,0,0,1.251.213,2.23,2.23,0,0,0,1.251-.5A.187.187,0,0,0,31.972,41.457Z",
    transform: "translate(-15.762 -29.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.281,41.6a.142.142,0,0,0-.176-.053,1.9,1.9,0,0,1-.969.142,1.775,1.775,0,0,1-.969-.373.137.137,0,0,0-.194,0l-.159.142a.163.163,0,0,0,0,.213,2.159,2.159,0,0,0,1.251.5,2.231,2.231,0,0,0,1.251-.213.143.143,0,0,0,.053-.2Z",
    transform: "translate(-37.49 -29.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.958,56.6a.462.462,0,1,0,.458.462A.446.446,0,0,0,28.958,56.6Z",
    transform: "translate(-15.02 -42.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.458,25.923A.462.462,0,1,0,60,25.462.457.457,0,0,0,60.458,25.923Z",
    transform: "translate(-40.971 -16.448)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.458,
    cy: 0.462,
    rx: 0.458,
    ry: 0.462,
    transform: "translate(15.471 7.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.058,54.3a.462.462,0,1,0,.458.462A.457.457,0,0,0,63.058,54.3Z",
    transform: "translate(-43.113 -40.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.558,25.923a.462.462,0,1,0-.458-.462A.457.457,0,0,0,31.558,25.923Z",
    transform: "translate(-17.162 -16.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.758,77.2a.462.462,0,1,0,.458.462A.468.468,0,0,0,52.758,77.2Z",
    transform: "translate(-34.627 -59.379)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergynew);
export default __webpack_public_path__ + "static/media/allergynew.5d9b38bcbc570a4173e20c718fa8f83b.svg";
export { ForwardRef as ReactComponent };